import React from 'react';
import Dialog from '@material-ui/core/Dialog'
import styles from './style.module.css' 
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton' 
import Table from "../../../views/Table/Table.js";


const ProductDetail = (props) => {
    let parts = [];
    let series = [];
    let categories = [];
    let warehouse = [];
    let totalCBM = 0;
   props.product.productParts.forEach(val => {
       totalCBM += val.partId.length * val.partId.width * val.partId.height
        val.partId && parts.push([
            val.partId.partName,
            val.partId.parts_barcode,
            val.partId.status,
            val.partId.length,
            val.partId.width,
            val.partId.height,
            val.partId.weight, 
        ])
    });
    props.product.categories && categories.push([
        props.product.categories.categoryName,
        props.product.categories.categories_barcode,
        props.product.categories.status
    ])
    props.product.series && series.push([
        props.product.series.seriesName,
        props.product.series.series_barcode,
        props.product.series.status
    ])
    props.product.warehouseId && warehouse.push([
        props.product.warehouseId.name,
        props.product.warehouseId.warehouseLocation,
        props.product.warehouseId.contactNum,
        props.product.warehouseId.address
    ])

 
    
    return (
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'lg'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    
                    <div className={styles.header}>
                        <h1>Product Detail</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div>
 
                    <div className={styles.content}>
                        <div className={styles.row}>
                            <p>
                                Product Barcode: 
                                <span>{props.product.product_barcode}</span>
                            </p>
                            <p>
                                Product Name: 
                                <span>{props.product.productName}</span>
                            </p>

                            <p>
                                Product MRP: 
                                <span>{props.product.productCost}</span>
                            </p>   

                            <p>
                                Product Status: 
                                <span>{props.product.status}</span>
                            </p>

                            <p>
                                Product Weight: 
                                <span>{props.product.weight}</span>
                            </p>
                            <p>
                                Product Length: 
                                <span>{props.product.length}</span>
                            </p>
                            <p>
                                Product Width: 
                                <span>{props.product.width}</span>
                            </p>
                            <p>
                                Product Height: 
                                <span>{props.product.height}</span>
                            </p>  
                            <p>
                                Total CBM: 
                                <span>{totalCBM}</span>
                            </p>  
                        </div>
                    </div> 
                    <h2>Product Category Detail</h2>
                    <Table
                        tableHeaderColor="primary"
                        tableHead={["Name", "Barcode", "Status"]}
                        tableData={categories}
                    />  
                    <h2>Product Series Details</h2>
                    <Table
                        tableHeaderColor="primary"
                        tableHead={["Name", "Barcode", "Status"]}
                        tableData={series}
                    />  
                    <h2>Product Part Details</h2>
                    <Table
                        tableHeaderColor="primary"
                        tableHead={["Name", "Barcode", "Status","Length","Width","height","Weight"]}
                        tableData={parts}
                    />  

                    <h2>Product Images</h2>

                    <div className={styles.imgContainer}>
                        {props.product.productImage.map(val => {
                            return (
                                <img src={val.imgUrl} className={styles.img} />
                            )
                        })}
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default ProductDetail;